import { BoardAdd, Document, Pointer } from '@air/next-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

export type GetCreateMenuOptionsParams = {
  onAddSubBoard?: () => void;
  onCreateBoard?: () => void;
  onCreateCanvas?: () => void;
  onCollectContent?: () => void;
};

export const getCreateMenuOptions = ({
  onAddSubBoard,
  onCreateBoard,
  onCreateCanvas,
  onCollectContent,
}: GetCreateMenuOptionsParams) => {
  const options: DropdownMenuOption[] = [];

  if (onCreateCanvas) {
    options.push({
      id: 'create-new-canvas',
      label: 'New canvas',
      description: 'Edit, refine, and multiply with AI',
      onSelect: onCreateCanvas,
      prefix: <Pointer className="size-4" />,
      type: 'item',
    });
  }

  if (onAddSubBoard) {
    if (options.length > 0) {
      options.push({
        id: 'add-sub-board-separator',
        type: 'separator',
      });
    }

    options.push({
      id: 'add-sub-board',
      label: 'Add Sub-board',
      onSelect: onAddSubBoard,
      prefix: <BoardAdd className="size-4" />,
      type: 'item',
    });
  }

  if (onCreateBoard) {
    if (options.length > 0) {
      options.push({
        id: 'create-board-separator',
        type: 'separator',
      });
    }

    options.push({
      id: 'create-new-board',
      label: 'Create new board',
      onSelect: onCreateBoard,
      prefix: <BoardAdd className="size-4" />,
      type: 'item',
    });
  }
  if (onCollectContent) {
    if (options.length > 0) {
      options.push({ id: 'cc-separator', type: 'separator' });
    }
    options.push({
      id: 'content-collection',
      label: 'Collect Content',
      description: 'Collect content directly from anyone, no Air account needed.',
      onSelect: onCollectContent,
      prefix: <Document className="size-4" />,
      type: 'item',
    });
  }

  return options;
};
